import type { BillLineView, OrderBill } from "../../interfaces/OrderObject";

/** Maps an order's stored bill onto the rows every bill surface renders. */
export function billToLineViews(bill: OrderBill | undefined): {
  lines: BillLineView[];
  charges: BillLineView[];
} {
  return {
    lines: (bill?.lines ?? []).map((line, i) => ({
      key: `${line.productId ?? line.productName}-${i}`,
      name: line.variantLabel ? `${line.productName} · ${line.variantLabel}` : line.productName,
      quantity: line.quantity,
      amount: line.lineTotal,
    })),
    charges: (bill?.charges ?? []).map((charge, i) => ({
      key: `charge-${i}`,
      name: charge.label,
      amount: charge.amount,
    })),
  };
}
